import React from 'react';
import { HighlightedServiceDto } from 'src/api/v2';
import { Skeleton, Card } from '@innovationnorway/cl-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface HighlightedServicesProps {
  data: HighlightedServiceDto[] | undefined;
  loading: boolean;
  onServiceClick?: (serviceId: string) => void;
}

const HighlightedServices = ({
  data: highlightedServices,
  loading,
  onServiceClick,
}: HighlightedServicesProps) => {
  const { t: tOneWayIn } = useTranslation('oneWayIn');

  if (loading) {
    return (
      <Card className="border--none">
        <Skeleton />
      </Card>
    );
  }

  if (!highlightedServices || highlightedServices.length === 0) {
    return null;
  }

  return (
    <Card className="border--none width--100 flex-grow--1 flex-shrink--1 flex-basis--0 box-sizing--border-box">
      <div className="stack margin--bottom--4 padding-bottom--12">
        <h2>{tOneWayIn('services.highlighted')}</h2>
        <p>{tOneWayIn('services.highlighted.description')}</p>
        <ul className="horizontal-divider padding-x--0 margin-top--3">
          {highlightedServices.map((service) => (
            <li key={service.id} className="display--block padding-x--1 padding-y--1 margin--0">
              <Link
                to={`/services/${service.oneWayInService.id}`}
                className="font-size--large"
                onClick={() => onServiceClick?.(service.oneWayInService.id!)}
              >
                {service.oneWayInService.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </Card>
  );
};

export default HighlightedServices;
